import {
  Components,
  Theme,
  outlinedInputClasses,
  breadcrumbsClasses,
} from '@mui/material';
import { iconButtonClasses } from '../iconButton';
import { Secondary } from '../color';
import { textFieldClasses } from '../textfield';

const AppBarHeight = 52;

export const MuiToolbar: Components<Theme>['MuiToolbar'] = {
  styleOverrides: {
    root: {
      height: AppBarHeight,
      '@media (min-width: 600px)': {
        minHeight: AppBarHeight,
      },
      [`.${textFieldClasses.root}`]: {

        maxWidth: 138,
        transition: 'max-width 0.3s ease',
        [`&:has(.${outlinedInputClasses.focused})`]: {
          maxWidth: 188,
        },

      },
      [`.${iconButtonClasses.root}`]: {
        borderRadius: 0,
      },
      [`.${breadcrumbsClasses.li}`]: {
        overflow: 'hidden',
        flex: 1,
        span: {
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          display: 'inline-block',
        },
      },
    },
  },
};

export const MuiAppBar: Components<Theme>['MuiAppBar'] = {
  styleOverrides: {
    root: {
      height: AppBarHeight,
      backgroundColor: 'transparent',
      boxShadow: 'none',
      borderBottom: `2px solid ${Secondary.default.main}`,
    },
  },
};
